<app-tab-button (onClick)="toggleShortlists()" [icon]="faHeart" label="SHORTLISTS"></app-tab-button>

<div appDisableBodyScroll class="shortlists-popup" *ngIf="showShortlistsPopup">
  <div class="popup-header shadow-sm p-2 d-flex align-items-center">
    <button class="btn" (click)="toggleShortlists()">
      <fa-icon [icon]="faTimes"></fa-icon>
    </button>
    <p class="mb-0"><b>SHORTLISTED CARS</b></p>
  </div>
  <div class="popup-content">
    <app-car-shortlist-content (onExploreCars)="toggleShortlists()"></app-car-shortlist-content>
  </div>
</div>